import setHiddenSlides from '../../../../src/js/set-hidden-slides';

// eslint-disable-next-line no-undef
new Swiper('.block-post-slider__slider', {
	slidesPerView: 1,
	spaceBetween: 12,
	loop: false,
	navigation: {
		nextEl: '.block-post-slider__next',
		prevEl: '.block-post-slider__prev',
	},
	breakpoints: {
		768: {
			slidesPerView: 2.2,
			spaceBetween: 16,
		},
		1440: {
			slidesPerView: 3.2,
			spaceBetween: 24,
		},
	},
	a11y: {
		slideLabelMessage: 'slide {{index}} of {{slidesLength}}',
	},
	on: {
		init: setHiddenSlides,
		slideChangeTransitionEnd: setHiddenSlides,
		breakpoint: setHiddenSlides,
	},
});
